import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { enqueueSnackbar } from 'notistack';

import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { MutationStateFns } from '@/api/utils/mutation';
import { Id, Uuid } from '@/api/utils/sql';
import { useAuth } from '@/context/AuthProvider';

export type ApiResponse_GenerateResponse_Sms = {
  sms: string;
  session_id: Uuid;
  urgent: false;
};

export type ApiRequest_GenerateResponse_Sms = {
  message: string;
  location_id: Id;
  tenant_id: Id;
  session_id: Uuid;
};

const METHOD = 'POST';
const ENDPOINT = 'twilio/generate';

export const useGenerateSmsResponse = (
  stateFns?: MutationStateFns<ApiResponse_GenerateResponse_Sms>
) => {
  const { session } = useAuth();

  return useMutation({
    mutationFn: async (data: ApiRequest_GenerateResponse_Sms) =>
      handleApiCall<ApiResponse_GenerateResponse_Sms, ApiRequest_GenerateResponse_Sms>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {}),
        data
      ),
    onSuccess: data => {
      enqueueSnackbar('AI response regenerated successfully', { variant: 'success' });

      stateFns?.onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      enqueueSnackbar('Failed to regenerate AI response', { variant: 'error' });

      // eslint-disable-next-line no-console
      console.error(err);
      stateFns?.onError?.(err);
    },
  });
};
